// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"168":"ae8291cf0f10b605345a","186":"e4e797c98e3d5512d8fc"}[chunkId] + ".js";
};